import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	LandFormInput,
	LandFormOutput,
} from "web_myplann/Portfolio/Forms/LandForm/landFormSchema";
import { FlatRowFormDatePicker } from "web_myplann/Shared/Components/FlatRow/FlatRowFormDatePicker";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";
import { DateView } from "web_myplann/Shared/Types/DateView";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import { UNITS } from "web_myplann/Shared/Utils/units";

type Props = {
	control: Control<LandFormInput, unknown, LandFormOutput>;
};

const PageResources = Resources.Portfolio.AddLand;

export const LandAreaAndDateFields = ({ control }: Props) => {
	const { t } = useResource();

	return (
		<>
			<FlatRowFormInput
				control={control}
				name="landSize"
				type="number"
				label={t(PageResources.Fields.landSize)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				suffix={UNITS.squareMeter}
			/>
			<FlatRowFormInput
				control={control}
				name="parcelNumber"
				label={t(PageResources.Fields.parcelNumber)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
			/>
			<FlatRowFormDatePicker
				control={control}
				name="purchaseDate"
				label={t(PageResources.Fields.purchaseDate)}
				views={[DateView.Year, DateView.Month, DateView.Day]}
				displayFormat={DateFormat.Display}
				placeholder={t(Resources.Portfolio.AddRealEstate.Placeholders.select)}
				isLast
			/>
		</>
	);
};
